import Type from "./Type";
import Head from "../index/Head";
import Active from "../../lib/Active";
import { getKidCallback, userClickReport } from "../../utils/kidCallback";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default (props) => {
  const searchStartClick = async () => {
    console.log("分类搜索开始点击");

    // 同步生成二级kid
    let kid = await getKidCallback();
    // 存储二级kid
    sessionStorage.setItem("boxSecondKid", kid);

    // 行为上报
    // 一级kid、二级kid都进行传递
    let reamrk = {
      search_click_time: dayjs().unix(),
      search_click_position: "分类",
    };
    userClickReport({
      target_id: 1,
      parent_id: "",
      kid,
      level: 2,
      action_code: "search_click",
      remark: JSON.stringify(reamrk),
    });
  };

  const location = useLocation();
  useEffect(() => {
    if (location.pathname === "/screen-game") {
      sessionStorage.removeItem("downParentKid");
      sessionStorage.removeItem("clickGameId");
    }
  }, [location.pathname]);

  return (
    <>
      <Active active={props.active}>
        <div className="game-index">
          <div onClick={searchStartClick}>
            <Head active={props.active} />
          </div>

          <div className="game-main">
            <div className="game-main-item active">
              <Type active={props.active} />
            </div>
          </div>
        </div>
      </Active>
    </>
  );
};
